import { useQuery } from '@tanstack/react-query';
import { fetchCoachAthletes } from '@/lib/templateApi';

export function useCoachAthletes() {
  return useQuery({
    queryKey: ['coachAthletes'],
    queryFn: fetchCoachAthletes,
  });
}
